<template>
  <div class="mobileCurriculum">
    <div class="exam-build-version">FE {{ buildVersion }}</div>
    <van-nav-bar
      :title="computedViewTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="loading loading--error-state" v-if="this.erroring">
      <div>{{ tips }}</div>
      <van-button
        type="primary"
        block
        class="reload-exam-btn"
        :loading="reloadExamLoading"
        @click="loadExamFromServer({ userClickedReload: true })"
      >
        重新加载
      </van-button>
    </div>
    <!-- 问卷填写页面 -->
    <Questionnaire
      v-if="showQuestionnaire"
      :exam-id="questionnaireApiExamId"
      :template-code="questionnaireTemplateCode"
      @submit-success="handleQuestionnaireSubmit"
      @go-back="handleQuestionnaireGoBack"
    />

    <div v-if="examFinishDialogVisible" class="exam-finish-mask">
      <div class="exam-finish-dialog">
        <div class="exam-finish-title" :class="examFinishDialogTitleClass">
          {{ examFinishDialogTitle }}
        </div>
        <div v-if="examFinishDialogContent" class="exam-finish-content">
          {{ examFinishDialogContent }}
        </div>
        <img
          v-if="examFinishDialogImage"
          class="exam-finish-image"
          :src="examFinishDialogImage"
          alt="考试结果"
        />
        <van-button
          type="primary"
          block
          class="exam-finish-confirm"
          @click="confirmExamFinishDialog"
        >
          确定
        </van-button>
      </div>
    </div>

    <van-overlay
      v-if="examUiState !== 'blocked'"
      :show="examLockVisible"
      z-index="3000"
    >
      <div class="exam-lock-mask">
        <van-loading
          v-if="examUiState !== 'blocked'"
          color="#1989fa"
          size="28px"
        />
        <div class="exam-lock-text">{{ examLockText }}</div>
      </div>
    </van-overlay>
    <div
      v-if="examUiState === 'blocked'"
      class="exam-lock-mask exam-lock-mask--blocked"
      :class="{ 'exam-lock-mask--takeover': canTakeoverExam }"
    >
      <div class="exam-lock-text">{{ sessionConflictMessage || examLockText }}</div>
      <van-button
        v-if="canTakeoverExam"
        type="primary"
        class="exam-takeover-btn"
        :loading="takeoverLoading"
        :disabled="takeoverLoading"
        @click="takeoverExamSession"
      >
        接管本次考试
      </van-button>
    </div>

    <div class="exam-content" v-if="!this.erroring && !showQuestionnaire">
      <!-- 考试信息卡片（固定在顶部） -->
      <div class="exam-info-card">
        <div class="exam-title">{{ itemData && itemData.title }}</div>
        <div class="exam-meta">
          <div class="meta-item">
            <span class="meta-label">剩余时间</span>
            <span
              class="meta-value time-value"
              :class="{ 'time-warning': isTimeWarning }"
              >{{ timer }}</span
            >
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">当前进度</span>
            <span class="meta-value"
              >{{ examination && examination.index + 1 }}/{{
                examination && examination.total
              }}</span
            >
          </div>
        </div>
      </div>

      <!-- 题目内容区域 -->
      <div
        class="question-content"
        v-if="examination && !adjustment && examination.subject"
        :class="{ 'has-fixed-buttons': !isScrolledToBottom }"
      >
        <div class="question-card">
          <div class="question-header">
            <span class="question-type-badge">
              {{
                examination.subject.type == "SC"
                  ? "单选题"
                  : examination.subject.type == "MC"
                  ? "多选题"
                  : examination.subject.type == "TF"
                  ? "判断题"
                  : "简答题"
              }}
            </span>
            <span class="question-number"
              >第 {{ examination.index + 1 }}/{{ examination.total }} 题</span
            >
          </div>

          <div class="question-title">
            {{ examination.subject.title }}
          </div>

          <!-- 单选题：交互式卡片样式 -->
          <div
            v-if="examination.subject.type == 'SC'"
            class="options-container"
          >
            <div
              v-for="(opt, _opt) in examination.subject.options"
              :key="_opt"
              class="option-card"
              :class="{ selected: examination.value === opt.index }"
              @click="selectSingleChoice(opt.index)"
            >
              <span class="option-label"
                >{{ String.fromCharCode(65 + _opt) }}.</span
              >
              <span class="option-text">{{ opt.title }}</span>
              <span
                class="option-radio"
                :class="{ checked: examination.value === opt.index }"
              ></span>
            </div>
          </div>

          <!-- 多选题：交互式卡片样式 -->
          <div
            v-if="examination.subject.type == 'MC'"
            class="options-container"
          >
            <div
              v-for="(opt, _opt) in examination.subject.options"
              :key="_opt"
              class="option-card checkbox-option"
              :class="{
                selected: (examination.value || []).includes(opt.index),
              }"
              @click="toggleMultipleChoice(opt.index)"
            >
              <span class="option-label"
                >{{ String.fromCharCode(65 + _opt) }}.</span
              >
              <span class="option-text">{{ opt.title }}</span>
              <span
                class="option-checkbox"
                :class="{
                  checked: (examination.value || []).includes(opt.index),
                }"
              ></span>
            </div>
          </div>

          <!-- 判断题：交互式卡片样式 -->
          <div
            v-if="examination.subject.type == 'TF'"
            class="options-container"
          >
            <div
              class="option-card"
              :class="{ selected: examination.value === true }"
              @click="selectTrueFalse(true)"
            >
              <span class="option-label">A.</span>
              <span class="option-text">是</span>
              <span
                class="option-radio"
                :class="{ checked: examination.value === true }"
              ></span>
            </div>
            <div
              class="option-card"
              :class="{ selected: examination.value === false }"
              @click="selectTrueFalse(false)"
            >
              <span class="option-label">B.</span>
              <span class="option-text">否</span>
              <span
                class="option-radio"
                :class="{ checked: examination.value === false }"
              ></span>
            </div>
          </div>

          <!-- 简答题 -->
          <div
            v-if="examination.subject.type == 'QA'"
            class="textarea-container"
          >
            <el-input
              type="textarea"
              :rows="8"
              placeholder="请在该区域内作答"
              v-model="examination.value"
              :disabled="isExamInteractionLocked"
              class="answer-textarea"
            >
            </el-input>
          </div>
        </div>

        <!-- 导航按钮（在内容流中的原始位置） -->
        <div v-if="isScrolledToBottom" class="nav-buttons relative-position">
          <van-button
            type="primary"
            block
            @click="submit"
            :loading="submitLoading"
            :disabled="isExamInteractionLocked || !hasAnswer"
            class="nav-btn next-btn"
          >
            {{ examination.total != examination.index + 1 ? "下一题" : "提交" }}
          </van-button>
        </div>
      </div>

      <!-- 导航按钮（固定定位，悬浮在底部） -->
      <div
        v-if="
          examination &&
          !adjustment &&
          examination.subject &&
          !isScrolledToBottom
        "
        class="nav-buttons fixed-bottom"
      >
        <van-button
          type="primary"
          block
          @click="submit"
          :loading="submitLoading"
          :disabled="isExamInteractionLocked || !hasAnswer"
          class="nav-btn next-btn"
        >
          {{ examination.total != examination.index + 1 ? "下一题" : "提交" }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import Questionnaire from "./Questionnaire.vue";
import examSubmitSync from "../../utils/examSubmitSync.cjs";
import { resolveBuildVersion } from "../../utils/buildVersion.cjs";
export default {
  name: "examination",
  components: {
    Questionnaire,
  },
  data() {
    return {
      buildVersion: resolveBuildVersion(process.env),
      timer: "00:00",
      totalTime: 0,
      examination: null,
      itemData: null,
      erroring: false,
      countdownTimer: null,
      heartbeatTimer: null,
      heartbeatInterval: 30000,
      adjustment: false, // 是否处于调整状态
      // 问卷相关
      showQuestionnaire: false,
      questionnaireTemplateCode: null,
      viewTitle: "考试", // 默认标题
      // 滚动相关
      _isScrolledToBottom: true, // 是否滚动到底部（内部状态）
      scrollCheckTimer: null, // 滚动检测防抖定时器
      submitLoading: false,
      syncRetryCount: 0,
      reloadExamLoading: false,
      finishingExam: false,
      examFinishDialogVisible: false,
      examFinishDialogTitle: "",
      examFinishDialogContent: "",
      examFinishDialogImage: "",
      examFinishDialogTitleClass: "",
      examFinishDialogResolve: null,
      examUiState: "loading",
      examLockMessage: "",
      examClientSessionId: "",
      currentSubmissionId: "",
      activeExamStorageKey: "",
      activeExamStorageValue: "",
      canTakeoverExam: false,
      takeoverLoading: false,
      sessionConflictMessage: "",
      storageConfirmTimer: null,
      storageConfirmInFlight: false,
      isLeavingExamPage: false,
    };
  },
  computed: {
    // 动态计算标题
    computedViewTitle() {
      // 显示考试名称（从路由参数或考试数据中获取）
      if (this.itemData && this.itemData.title) {
        return this.itemData.title;
      }
      if (this.examination && this.examination.title) {
        return this.examination.title;
      }
      return this.viewTitle || "考试";
    },
    // 是否有答案
    hasAnswer() {
      if (!this.examination || !this.examination.subject) {
        return false;
      }
      const value = this.examination.value;
      if (this.examination.subject.type === "MC") {
        return Array.isArray(value) && value.length > 0;
      }
      if (this.examination.subject.type === "QA") {
        return value && typeof value === "string" && value.trim().length > 0;
      }
      return value !== null && value !== undefined;
    },
    // 时间警告（剩余时间少于10分钟）
    isTimeWarning() {
      return this.totalTime > 0 && this.totalTime < 600; // 10分钟 = 600秒
    },
    // 是否滚动到底部
    isScrolledToBottom() {
      // 这个值会在 mounted 和 scroll 事件中更新
      return this._isScrolledToBottom !== false;
    },
    /**
     * 与 POST /api/my/exam/start/{id}、GET /api/my/exam/{id}/questionnaire 使用同一 ID：考试定义 Examination.id（路由 query.examinationId）。
     * 禁止用接口返回的 data.id（学员考试记录 StudentExamination.id），否则问卷接口必失败。
     */
    questionnaireApiExamId() {
      const raw =
        this.$route.query?.examinationId ?? this.itemData?.examinationId;
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },
    isExamInteractionLocked() {
      return ["submitting", "confirming", "syncing", "finished", "blocked"].includes(
        this.examUiState
      );
    },
    examLockVisible() {
      return ["submitting", "confirming", "syncing", "blocked"].includes(
        this.examUiState
      );
    },
    examLockText() {
      if (this.examLockMessage) return this.examLockMessage;
      if (this.examUiState === "submitting") return "\u6b63\u5728\u63d0\u4ea4\u7b54\u6848";
      if (this.examUiState === "confirming") return "\u6b63\u5728\u786e\u8ba4\u63d0\u4ea4\u7ed3\u679c";
      if (this.examUiState === "syncing") return "\u6b63\u5728\u540c\u6b65\u6700\u65b0\u9898\u76ee";
      if (this.examUiState === "blocked") return "\u8003\u8bd5\u5df2\u5728\u5176\u4ed6\u9875\u9762\u6253\u5f00";
      return "\u6b63\u5728\u5904\u7406";
    },
  },
  created() {
    this.itemData = this.$route.query || null;
    this.loadExamFromServer();
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    window.addEventListener("popstate", this.handlePopState);
    window.addEventListener("storage", this.handleExamStorageChange);
    history.pushState({ examGuard: true }, "", window.location.href);
    // 初始检查滚动位置
    this.$nextTick(() => {
      this.checkScrollPosition();
    });
  },
  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    window.removeEventListener("popstate", this.handlePopState);
    window.removeEventListener("storage", this.handleExamStorageChange);
    this.releaseActiveExamTab();
    // 清除定时器
    if (this.scrollCheckTimer) {
      clearTimeout(this.scrollCheckTimer);
    }
    if (this.storageConfirmTimer) {
      clearTimeout(this.storageConfirmTimer);
      this.storageConfirmTimer = null;
    }
    this.stopHeartbeat();
    this.stopCountdown();
  },
  methods: {
    setExamUiState(state, message = "") {
      this.examUiState = state;
      this.examLockMessage = message;
    },
    extractErrorObject(error) {
      const body =
        error && error.response && error.response.data !== undefined
          ? error.response.data
          : error && error.data !== undefined
          ? error.data
          : error || {};
      return body && typeof body === "object" ? body : {};
    },
    getErrorCode(error) {
      const errObj = this.extractErrorObject(error);
      return errObj.errorCode || errObj.code;
    },
    isExamSessionProblemCode(code) {
      return code === "exam_session_conflict" || code === "exam_session_kicked";
    },
    enterExamSessionProblem(code) {
      const kicked = code === "exam_session_kicked";
      const message = kicked
        ? "本次考试已被另一页面接管。如你正在现场考试，可重新接管。"
        : "本次考试已在其他页面打开。若你正在现场考试，可接管本次考试；接管后其他页面将无法继续提交。";
      this.sessionConflictMessage = message;
      this.canTakeoverExam = true;
      this.takeoverLoading = false;
      this.erroring = false;
      this.tips = message;
      this.stopHeartbeat();
      this.stopCountdown();
      if (this.storageConfirmTimer) {
        clearTimeout(this.storageConfirmTimer);
        this.storageConfirmTimer = null;
      }
      this.setExamUiState("blocked", message);
    },
    clearExamSessionProblem() {
      this.sessionConflictMessage = "";
      this.canTakeoverExam = false;
      this.takeoverLoading = false;
    },
    handleStartExamError(error) {
      const code = this.getErrorCode(error);
      if (this.isExamSessionProblemCode(code)) {
        this.enterExamSessionProblem(code);
        return true;
      }
      return false;
    },
    createClientId(prefix) {
      return `${prefix}-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 10)}`;
    },
    ensureExamClientSessionId() {
      if (!this.examClientSessionId) {
        const examRouteId =
          this.itemData?.examinationId ||
          this.$route.query?.examinationId ||
          "unknown";
        this.examClientSessionId = this.createClientId(
          `exam-session-${examRouteId}`
        );
      }
      return this.examClientSessionId;
    },
    createSubmissionId() {
      const examId = this.examination?.id || "unknown";
      const index = this.examination?.index ?? "unknown";
      return this.createClientId(`submit-${examId}-${index}`);
    },
    ensureCurrentSubmissionId() {
      if (!this.currentSubmissionId) {
        this.currentSubmissionId = this.createSubmissionId();
      }
      return this.currentSubmissionId;
    },
    selectSingleChoice(optionIndex) {
      if (this.isExamInteractionLocked) return;
      this.examination.value = optionIndex;
    },
    selectTrueFalse(value) {
      if (this.isExamInteractionLocked) return;
      this.examination.value = value;
    },
    shouldBlockExamLeave() {
      if (this.isLeavingExamPage) return false;
      if (
        !this.examination ||
        this.examUiState === "finished" ||
        this.examUiState === "blocked"
      ) {
        return false;
      }
      return true;
    },
    handleBeforeUnload(event) {
      if (!this.shouldBlockExamLeave()) return;
      event.preventDefault();
      event.returnValue = "\u8003\u8bd5\u6b63\u5728\u8fdb\u884c\u4e2d\uff0c\u79bb\u5f00\u9875\u9762\u53ef\u80fd\u5f71\u54cd\u63d0\u4ea4\u7ed3\u679c\u3002";
      return event.returnValue;
    },
    handlePopState() {
      if (!this.shouldBlockExamLeave()) return;
      history.pushState({ examGuard: true }, "", window.location.href);
      if (this.isExamInteractionLocked) {
        this.$toast("\u6b63\u5728\u5904\u7406\u63d0\u4ea4\uff0c\u8bf7\u7a0d\u5019");
        return;
      }
      Dialog.confirm({
        title: "\u79bb\u5f00\u8003\u8bd5\uff1f",
        message: "\u8003\u8bd5\u6b63\u5728\u8fdb\u884c\u4e2d\uff0c\u79bb\u5f00\u9875\u9762\u53ef\u80fd\u5f71\u54cd\u7b54\u9898\u8fdb\u5ea6\u3002",
        confirmButtonText: "\u79bb\u5f00",
        cancelButtonText: "\u7ee7\u7eed\u8003\u8bd5",
      })
        .then(() => {
          this.isLeavingExamPage = true;
          this.finishExamAndLeave();
        })
        .catch(() => {});
    },
    registerActiveExamTab(studentExamId) {
      const tabId = this.ensureExamClientSessionId();
      const key = `tecs-active-exam-${studentExamId}`;
      const existingRaw = localStorage.getItem(key);
      if (existingRaw) {
        try {
          const existing = JSON.parse(existingRaw);
          const isStale =
            !existing.updatedAt ||
            Date.now() - Number(existing.updatedAt || 0) >= 120000;
          if (existing.tabId && existing.tabId !== tabId && isStale) {
            localStorage.removeItem(key);
          }
        } catch (_e) {
          // Ignore malformed cross-tab marker and let the current tab claim it.
        }
      }
      const value = JSON.stringify({
        tabId,
        studentExamId,
        updatedAt: Date.now(),
      });
      localStorage.setItem(key, value);
      this.activeExamStorageKey = key;
      this.activeExamStorageValue = value;
      return true;
    },
    refreshActiveExamTab() {
      if (!this.activeExamStorageKey || !this.activeExamStorageValue) return;
      try {
        const payload = JSON.parse(this.activeExamStorageValue);
        payload.updatedAt = Date.now();
        this.activeExamStorageValue = JSON.stringify(payload);
        localStorage.setItem(this.activeExamStorageKey, this.activeExamStorageValue);
      } catch (_e) {
        // Ignore malformed local active-tab payload; next heartbeat will refresh it.
      }
    },
    handleExamStorageChange(event) {
      if (
        !this.activeExamStorageKey ||
        event.key !== this.activeExamStorageKey ||
        !event.newValue
      ) {
        return;
      }
      if (event.newValue !== this.activeExamStorageValue) {
        this.scheduleExamSessionConfirmation();
      }
    },
    shouldSkipStorageSessionConfirmation() {
      return (
        this.canTakeoverExam ||
        this.examUiState === "blocked" ||
        ["submitting", "confirming", "syncing"].includes(this.examUiState)
      );
    },
    scheduleExamSessionConfirmation() {
      if (this.shouldSkipStorageSessionConfirmation()) {
        return;
      }
      if (this.storageConfirmTimer) {
        clearTimeout(this.storageConfirmTimer);
      }
      this.storageConfirmTimer = setTimeout(() => {
        this.storageConfirmTimer = null;
        this.confirmExamSessionStillActive();
      }, 1000);
    },
    confirmExamSessionStillActive() {
      if (
        this.shouldSkipStorageSessionConfirmation() ||
        this.storageConfirmInFlight
      ) {
        return;
      }
      this.storageConfirmInFlight = true;
      Promise.resolve(this.fetchHeartbeat({ force: true })).finally(() => {
        this.storageConfirmInFlight = false;
      });
    },
    releaseActiveExamTab() {
      if (!this.activeExamStorageKey) return;
      if (
        localStorage.getItem(this.activeExamStorageKey) ===
        this.activeExamStorageValue
      ) {
        localStorage.removeItem(this.activeExamStorageKey);
      }
    },
    setTimer(initialSeconds) {
      if (typeof initialSeconds === "number") {
        this.totalTime = initialSeconds;
      }
      this.stopCountdown();
      this.updateTimerDisplay();
      this.countdownTimer = setInterval(() => {
        if (this.totalTime > 0) {
          this.totalTime--;
          this.updateTimerDisplay();
        } else {
          this.handleHeartbeatTimeout();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    updateTimerDisplay() {
      const total = Number(this.totalTime) || 0;
      // 限制最大显示时间（避免异常值）
      const maxTime = 99 * 3600 + 59 * 60 + 59; // 99:59:59
      const clampedTotal = Math.min(Math.max(0, total), maxTime);
      const hour = parseInt(clampedTotal / 3600);
      const minute = parseInt((clampedTotal % 3600) / 60);
      const second = parseInt(clampedTotal % 60);
      const pad = (num) => String(num).padStart(2, "0");
      // 如果超过1小时，显示小时；否则只显示分钟和秒
      if (hour > 0) {
        this.timer = `${pad(hour)}:${pad(minute)}:${pad(second)}`;
      } else {
        this.timer = `${pad(minute)}:${pad(second)}`;
      }
    },
    syncLeftTime(leftTime) {
      if (typeof leftTime === "number") {
        this.totalTime = leftTime;
        this.updateTimerDisplay();
        if (leftTime <= 0) {
          this.handleHeartbeatTimeout();
        }
      }
    },
    startHeartbeat() {
      this.stopHeartbeat();
      if (!this.examination || !this.examination.id) {
        return;
      }
      this.fetchHeartbeat();
      this.heartbeatTimer = setInterval(() => {
        this.fetchHeartbeat();
      }, this.heartbeatInterval);
    },
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },
    buildExamHeartbeatPayload() {
      const payload = {
        clientSessionId: this.ensureExamClientSessionId(),
      };
      // H5 currently has no monitoring session state; include it only when one is available.
      const monitoringSessionId = [
        this.currentSessionId,
        this.monitoringSessionId,
        this.sessionId,
      ].find((value) => value !== undefined && value !== null && value !== "");
      if (monitoringSessionId) {
        payload.monitoringSessionId = monitoringSessionId;
        payload.sessionId = monitoringSessionId;
      }
      return payload;
    },
    fetchHeartbeat(options = {}) {
      if (!this.examination || !this.examination.id) {
        return;
      }
      if (
        !options.force &&
        ["syncing", "submitting", "confirming"].includes(this.examUiState)
      ) {
        return;
      }
      return this.$https
        .post(
          "/api/my/exam/heartbeat/" + this.examination.id,
          this.buildExamHeartbeatPayload(),
          { skipGlobalErrorToast: true }
        )
        .then((res) => {
          if (res.success && res.data) {
            const data = res.data;
            if (data.sessionState === "kicked") {
              this.enterExamSessionProblem("exam_session_kicked");
              return;
            }
            if (data.sessionState === "expired_or_empty") {
              return;
            }
            this.syncLeftTime(data.leftTime);
            this.refreshActiveExamTab();
            if (
              data.subjectIndex !== undefined &&
              data.subjectIndex !== this.examination.index &&
              !["syncing", "submitting", "confirming"].includes(this.examUiState)
            ) {
              this.loadExamFromServer({
                isAutoSync: true,
                silentSuccess: true,
              });
              return;
            }
            if (data.stateVersion !== undefined) {
              this.examination.stateVersion = data.stateVersion;
            }
            if (data.status && data.status !== this.examination.status) {
              this.examination.status = data.status;
            }
            if (data.status && data.status !== "processing") {
              this.handleHeartbeatTimeout();
            }
          }
        })
        .catch((error) => {
          if (this.getErrorCode(error) === "exam_session_kicked") {
            this.enterExamSessionProblem("exam_session_kicked");
            return;
          }
          // 心跳失败忽略，保持现有倒计时
        });
    },
    handleHeartbeatTimeout() {
      if (this.isDone) {
        return;
      }
      this.stopHeartbeat();
      this.stopCountdown();
      this.isDone = true;
      this.$alert("考试时间已结束，系统将退出考试。", "提示", {
        confirmButtonText: "确定",
        center: true,
        callback: () => {
          this.onClickLeft();
        },
      });
    },
    // 切换多选题选项
    toggleMultipleChoice(optionIndex) {
      if (this.isExamInteractionLocked) return;
      if (!this.examination || this.examination.subject.type !== "MC") {
        return;
      }
      if (!Array.isArray(this.examination.value)) {
        this.examination.value = [];
      }
      const index = this.examination.value.indexOf(optionIndex);
      if (index > -1) {
        this.examination.value.splice(index, 1);
      } else {
        this.examination.value.push(optionIndex);
      }
    },
    // 检查滚动位置
    checkScrollPosition() {
      if (this.scrollCheckTimer) {
        clearTimeout(this.scrollCheckTimer);
      }
      this.scrollCheckTimer = setTimeout(() => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const scrollBottom = scrollTop + windowHeight;
        // 判断是否滚动到底部（允许80px的误差）
        const isAtBottom = scrollBottom >= documentHeight - 80;
        this._isScrolledToBottom = isAtBottom;
      }, 200);
    },
    // 处理滚动事件
    handleScroll() {
      this.checkScrollPosition();
    },
    applyStartedExamData(data, options = {}) {
      const { isAutoSync = false, silentSuccess = false } = options;
      if (!data) {
        return false;
      }
      if (data.id && !this.registerActiveExamTab(data.id)) {
        return false;
      }
      this.refreshActiveExamTab();
      this.clearExamSessionProblem();
      this.currentSubmissionId = "";

      if (
        data.needQuestionnaire &&
        data.questionsFinished &&
        !data.questionnaireFinished
      ) {
        this.erroring = false;
        if (this.questionnaireApiExamId <= 0) {
          const message = "页面缺少考试编号，请返回课程页重新进入考试";
          this.$toast.fail(message);
          this.setExamUiState("blocked", message);
          return false;
        }
        this.showQuestionnaire = true;
        this.questionnaireTemplateCode = data.questionnaireTemplateCode;
        this.examination = {
          id: data.id,
          ...data,
        };
        this.stopHeartbeat();
        this.stopCountdown();
        this.setExamUiState("answering");
        if (isAutoSync && !silentSuccess) {
          this.$toast.success("已同步，请继续填写问卷");
        }
        return true;
      }

      if (!data.subject) {
        this.showQuestionnaire = false;
        this.stopHeartbeat();
        this.stopCountdown();
        this.erroring = true;
        this.tips =
          "考试数据异常，请检查网络后点击下方“重新加载”。若多次失败请联系监考老师。";
        this.setExamUiState("blocked", this.tips);
        return false;
      }

      this.erroring = false;
      this.showQuestionnaire = false;
      this.examination = this.normalizeExamData(data);
      this.setTimer(data.leftTime);
      this.startHeartbeat();
      this.setExamUiState("answering");
      if (isAutoSync && !silentSuccess) {
        this.$toast.success("已同步最新题目");
      }
      return true;
    },
    /**
     * 唯一入口：从后端拉取考试 / 问卷入口状态
     * @param {{ isAutoSync?: boolean }} options
     */
    async loadExamFromServer(options = {}) {
      const {
        isAutoSync = false,
        userClickedReload = false,
        silentSuccess = false,
      } = options;
      const examRouteId =
        this.itemData?.examinationId || this.$route.query?.examinationId;
      if (!examRouteId) {
        this.erroring = true;
        this.tips = "缺少考试参数，无法加载考试";
        this.setExamUiState("blocked", this.tips);
        return false;
      }

      if (userClickedReload) {
        this.reloadExamLoading = true;
      }
      if (isAutoSync) {
        this.setExamUiState("syncing");
      } else if (this.examUiState !== "blocked") {
        this.setExamUiState("loading");
      }

      try {
        const clientSessionId = this.ensureExamClientSessionId();
        const res = await this.$https.post(
          "/api/my/exam/start/" + examRouteId,
          { clientSessionId, takeover: false },
          { skipGlobalErrorToast: true }
        );

        if (!res.success) {
          if (this.handleStartExamError(res)) {
            return false;
          }
          const loadMsg = res.message || res.debug || "加载失败";
          if (this.isTerminalExamFinishMessage(loadMsg)) {
            await this.handleTerminalExamFinished(loadMsg);
            return false;
          }
          if (!isAutoSync) {
            this.erroring = true;
            this.tips = "错误：" + loadMsg;
            this.setExamUiState("blocked", this.tips);
          } else {
            this.setExamUiState("answering");
            this.$toast.fail(loadMsg);
          }
          return false;
        }

        const data = res.data || {};
        return this.applyStartedExamData(data, { isAutoSync, silentSuccess });
      } catch (error) {
        if (this.handleStartExamError(error)) {
          return false;
        }
        const loadMsg = this.extractHttpErrorMessage(error);
        if (this.isTerminalExamFinishMessage(loadMsg)) {
          await this.handleTerminalExamFinished(loadMsg);
          return false;
        }
        if (!isAutoSync) {
          this.erroring = true;
          this.tips = "错误：" + (loadMsg || "未知错误");
          this.setExamUiState("blocked", this.tips);
        } else {
          this.setExamUiState("answering");
          this.$toast.fail(loadMsg || "网络异常，请检查网络后重试");
        }
        return false;
      } finally {
        this.reloadExamLoading = false;
      }
    },
    async takeoverExamSession() {
      if (this.takeoverLoading) {
        return;
      }
      const examRouteId =
        this.itemData?.examinationId || this.$route.query?.examinationId;
      if (!examRouteId) {
        this.$toast.fail("页面缺少考试编号，请返回课程页重新进入考试");
        return;
      }
      this.takeoverLoading = true;
      try {
        const res = await this.$https.post(
          "/api/my/exam/start/" + examRouteId,
          {
            clientSessionId: this.ensureExamClientSessionId(),
            takeover: true,
          },
          { skipGlobalErrorToast: true }
        );
        if (res.success && res.data) {
          this.applyStartedExamData(res.data);
          return;
        }
        if (!this.handleStartExamError(res)) {
          this.$toast.fail(res.message || res.debug || "接管失败，请稍后重试");
        }
      } catch (error) {
        if (!this.handleStartExamError(error)) {
          const message = this.extractHttpErrorMessage(error);
          this.$toast.fail(message || "接管失败，请稍后重试");
        }
      } finally {
        if (this.canTakeoverExam) {
          this.takeoverLoading = false;
        }
      }
    },
    isTerminalExamFinishMessage(message) {
      const text = String(message || "");
      const terminalMessages = [
        "该考试已结束",
        "考试已结束",
        "问卷已完成",
        "考试次数已用完",
        "无法再次进入问卷页面",
        "考试期已结束",
      ];
      return terminalMessages.some((item) => text.includes(item));
    },
    findCurrentExamInRegistration(registration) {
      const examRouteId = String(
        this.itemData?.examinationId || this.$route.query?.examinationId || ""
      );
      if (!registration || !examRouteId) {
        return null;
      }
      const exams = Array.isArray(registration.exam)
        ? registration.exam
        : Array.isArray(registration.exams)
        ? registration.exams
        : Array.isArray(registration.examination)
        ? registration.examination
        : [];
      return (
        exams.find((item) => {
          const ids = [
            item?.examId,
            item?.examinationId,
            item?.id,
            item?.originExam?.id,
            item?.originExam?.examinationId,
          ].map((value) => String(value || ""));
          return ids.includes(examRouteId);
        }) || null
      );
    },
    async resolveExamFinishTarget() {
      const registrationId = this.$route.query?.registrationId;
      const safeFallbackTarget = {
        path: "/mobileHome",
      };
      const examListTarget = {
        path: "/courseDetail",
        query: {
          id: registrationId,
          step: "3",
        },
      };
      const certificateTarget = {
        path: "/courseDetail",
        query: {
          id: registrationId,
          step: "4",
        },
      };

      if (!registrationId) {
        localStorage.removeItem("isShowCertificate");
        return safeFallbackTarget;
      }

      localStorage.removeItem("isShowCertificate");
      try {
        const res = await this.$https.get(
          "/api/my/registration/" + registrationId
        );
        if (!res.success) {
          return examListTarget;
        }
        const currentExam = this.findCurrentExamInRegistration(res.data);
        if (currentExam?.originExam?.certPass === true) {
          localStorage.setItem("isShowCertificate", "true");
          return certificateTarget;
        }
        return examListTarget;
      } catch (error) {
        console.log("[H5考试] 刷新报名详情失败，返回考试列表", error);
        return examListTarget;
      }
    },
    async finishExamAndLeave() {
      if (this.finishingExam) {
        return;
      }
      this.finishingExam = true;
      this.isLeavingExamPage = true;
      this.setExamUiState("finished");
      this.releaseActiveExamTab();
      try {
        localStorage.setItem("needRefreshCourseDetail", "true");
        this.showQuestionnaire = false;
        this.stopHeartbeat();
        this.stopCountdown();
        const target = await this.resolveExamFinishTarget();
        await this.$router.replace(target);
      } catch (error) {
        console.log("[H5考试] 完成考试后跳转失败", error);
        this.$toast.fail("返回失败，正在返回首页");
        try {
          await this.$router.replace({ path: "/mobileHome" });
        } catch (fallbackError) {
          console.log("[H5考试] 安全返回首页失败", fallbackError);
        }
      } finally {
        this.finishingExam = false;
      }
    },
    isTimeoutOrNetworkError(error) {
      if (!error) return false;
      if (error.isTimeout === true || error.isNetwork === true) return true;
      const msg = String(error.message || error.debug || "");
      const code = String(error.code || "");
      return code === "ECONNABORTED" || /timeout|network|超时|网络/i.test(msg);
    },
    extractHttpErrorMessage(error) {
      if (!error) return "网络异常，请检查网络后重试";
      const body =
        error.response?.data !== undefined
          ? error.response.data
          : error.data !== undefined
          ? error.data
          : error;
      if (typeof body === "string") return body;
      if (body && typeof body === "object") {
        return (
          body.debug ||
          body.message ||
          body.title ||
          body.error ||
          (body.message && String(body.message)) ||
          ""
        );
      }
      if (error.message && /network/i.test(String(error.message))) {
        return "网络异常，请检查网络后重试";
      }
      return error.message || "未知错误";
    },
    isSubjectIndexSyncError(text, errObj) {
      const t = (text || "").toString();
      const code = errObj && (errObj.errorCode || errObj.code);
      return (
        [
          "exam_index_mismatch",
          "exam_index_behind_unanswered",
          "exam_index_ahead",
          "EXAM_INDEX_MISMATCH",
        ].includes(code) ||
        t.includes("提交题目序号错误") ||
        t.includes("题目索引超出范围") ||
        t.includes("状态不同步")
      );
    },
    isRecoverableSubjectIndexSyncError(errObj, text) {
      return examSubmitSync.isRecoverableSubjectIndexSyncError(errObj, text);
    },
    async handleSubmitFailure(res, thrownPayload) {
      const fromRes =
        res &&
        (res.message ||
          res.debug ||
          (res.data && (res.data.message || res.data.debug)));
      const errObj =
        thrownPayload && typeof thrownPayload === "object" ? thrownPayload : {};
      const fromThrow =
        errObj.debug ||
        errObj.message ||
        errObj.title ||
        (typeof thrownPayload === "string" ? thrownPayload : "");
      const networkHint =
        thrownPayload &&
        thrownPayload.message &&
        /network|timeout|网络/i.test(String(thrownPayload.message))
          ? "网络异常，请检查网络后重试"
          : "";
      const text = [fromRes, fromThrow, networkHint].filter(Boolean).join(" ");
      const errorCode = this.getErrorCode(errObj) || this.getErrorCode(res);

      if (errorCode === "exam_session_kicked") {
        this.enterExamSessionProblem(errorCode);
        return false;
      }

      if (this.isSubjectIndexSyncError(text, errObj)) {
        if (!this.isRecoverableSubjectIndexSyncError(errObj, text)) {
          this.$toast.fail(text || "答题进度与服务器不一致，请刷新考试状态后重试或联系监考老师");
          return false;
        }
        if (this.syncRetryCount >= 3) {
          this.$toast.fail("同步失败次数过多，请稍后再试或联系监考老师");
          return false;
        }
        this.syncRetryCount += 1;
        const ok = await this.loadExamFromServer({
          isAutoSync: true,
          silentSuccess: this.syncRetryCount === 1,
        });
        if (ok) {
          this.syncRetryCount = 0;
          return true;
        }
        this.$toast("检测到进度与服务器不一致，请稍后重试或联系监考老师");
        return false;
      }

      this.$toast.fail(text || networkHint || "提交失败，请稍后重试");
      return false;
    },
    async submit() {
      if (this.submitLoading || this.isExamInteractionLocked) {
        return;
      }
      if (!this.hasAnswer) {
        this.$toast("请先作答");
        return;
      }
      this.submitLoading = true;
      this.setExamUiState("submitting");
      const submissionId = this.ensureCurrentSubmissionId();
      const clientSessionId = this.ensureExamClientSessionId();
      try {
        const res = await this.$https.post(
          "/api/my/exam/submitsubject/" + this.examination.id,
          {
            answer: this.examination.value,
            subjectIndex: this.examination.index,
            submissionId,
            clientSessionId,
            subjectId: this.examination.subject && this.examination.subject.id,
            stateVersion: this.examination.stateVersion,
          },
          { timeout: 60000, skipGlobalErrorToast: true }
        );

        if (!res.success) {
          await this.handleSubmitFailure(res, null);
          return;
        }

        const data = res.data || {};
        const subjectRoundDone = data.isDone === true || data.done === true;
        this.isDone = subjectRoundDone;
        this.currentSubmissionId = "";
        this.refreshActiveExamTab();

        if (
          data.needQuestionnaire &&
          data.questionsFinished &&
          !data.questionnaireFinished
        ) {
          if (this.questionnaireApiExamId <= 0) {
            this.$toast.fail("页面缺少考试编号，请返回课程页重新进入考试");
            this.setExamUiState("blocked", "页面缺少考试编号，请返回课程页重新进入考试");
            return;
          }
          this.erroring = false;
          this.syncRetryCount = 0;
          this.stopHeartbeat();
          this.stopCountdown();
          this.showQuestionnaire = true;
          this.questionnaireTemplateCode = data.questionnaireTemplateCode;
          this.examination = {
            ...this.examination,
            ...data,
          };
          this.setExamUiState("answering");
          return;
        }

        if (subjectRoundDone) {
          this.syncRetryCount = 0;
          this.stopHeartbeat();
          this.stopCountdown();
          this.setExamUiState("finished");

          if (!data.needQuestionnaire || data.questionnaireFinished) {
            const dialog = this.shouldShowExamResult(data)
              ? this.showResultDialog(data)
              : this.showExamCompleteDialog();
            dialog.then(() => this.finishExamAndLeave()).catch(() => this.finishExamAndLeave());
            return;
          }
        }

        if (!subjectRoundDone) {
          this.syncRetryCount = 0;
          this.examination = this.normalizeExamData(data);
          this.setTimer(data.leftTime);
          this.setExamUiState("answering");
        }
      } catch (error) {
        if (this.isTimeoutOrNetworkError(error)) {
          this.setExamUiState("confirming");
          const syncOk = await this.loadExamFromServer({
            isAutoSync: true,
            silentSuccess: true,
          });
          if (syncOk) {
            this.syncRetryCount = 0;
            this.currentSubmissionId = "";
            return;
          }
          this.$toast("提交请求超时，请稍后重试或联系监考老师");
          return;
        }
        if (error == null) {
          this.$toast.fail("网络异常，请检查网络后重试");
          return;
        }
        const errPayload =
          error && error.data !== undefined ? error.data : error;
        const terminalMessage = this.extractHttpErrorMessage(errPayload);
        if (this.isTerminalExamFinishMessage(terminalMessage)) {
          await this.handleTerminalExamFinished(terminalMessage);
          return;
        }
        await this.handleSubmitFailure(null, errPayload);
      } finally {
        this.submitLoading = false;
        if (["submitting", "confirming", "syncing"].includes(this.examUiState)) {
          this.setExamUiState("answering");
        }
      }
    },
    normalizeExamData(data) {
      return {
        ...data,
        value: data.subject.type == "MC" ? [] : null,
      };
    },
    handleTerminalExamFinished(message) {
      this.syncRetryCount = 0;
      this.stopHeartbeat();
      this.stopCountdown();
      this.setExamUiState("finished");
      return this.showExamCompleteDialog(message || "考试已完成")
        .then(() => {
          this.finishExamAndLeave();
        })
        .catch(() => {
          this.finishExamAndLeave();
        });
    },
    showExamCompleteDialog(message = "考试已完成") {
      return this.openExamFinishDialog({
        title: message,
      });
    },
    showResultDialog(data) {
      let tipsTxt = "很遗憾，您没有通过此次考试";
      let tipsTxtClass = "echoErrorTitle";
      if (data.pass) {
        tipsTxt = "恭喜您通过此次考试";
        tipsTxtClass = "echoPassTitle";
      }
      const displayContentText = data.displayContent || "";
      const src = data.displayImage ? this.$domainName + data.displayImage : "";
      return this.openExamFinishDialog({
        title: tipsTxt,
        content: displayContentText,
        titleClass: tipsTxtClass,
        image: src,
      });
    },
    openExamFinishDialog({ title, content = "", titleClass = "", image = "" }) {
      this.examFinishDialogTitle = title || "考试已完成";
      this.examFinishDialogContent = content || "";
      this.examFinishDialogImage = image || "";
      this.examFinishDialogTitleClass = titleClass || "";
      this.examFinishDialogVisible = true;
      return new Promise((resolve) => {
        this.examFinishDialogResolve = resolve;
      });
    },
    confirmExamFinishDialog() {
      this.examFinishDialogVisible = false;
      const resolve = this.examFinishDialogResolve;
      this.examFinishDialogResolve = null;
      if (resolve) {
        resolve();
      }
    },
    shouldShowExamResult(data) {
      return !!(
        data &&
        (data.needDisplay === true || data.displayResult === true)
      );
    },
    onClickLeft() {
      if (this.examUiState === "blocked") {
        this.isLeavingExamPage = true;
        this.releaseActiveExamTab();
        this.finishExamAndLeave();
        return;
      }
      if (this.isExamInteractionLocked) {
        this.$toast("正在处理提交，请稍候");
        return;
      }
      if (this.shouldBlockExamLeave()) {
        Dialog.confirm({
          title: "离开考试？",
          message: "考试正在进行中，离开页面可能影响答题进度。",
          confirmButtonText: "离开",
          cancelButtonText: "继续考试",
        })
          .then(() => {
            this.isLeavingExamPage = true;
            this.finishExamAndLeave();
          })
          .catch(() => {});
        return;
      }
      const registrationId = this.$route.query?.registrationId;
      if (registrationId) {
        localStorage.setItem("needRefreshCourseDetail", "true");
        this.$router.replace({
          path: "/courseDetail",
          query: {
            id: registrationId,
            step: "3",
          },
        });
      } else {
        this.$router.back();
      }
    },


    // 问卷提交成功处理
    handleQuestionnaireSubmit(examResult) {
      localStorage.setItem("needRefreshCourseDetail", "true");
      this.stopHeartbeat();
      this.stopCountdown();
      this.showQuestionnaire = false;
      this.setExamUiState("finished");
      const data = examResult || {};
      const dialog = this.shouldShowExamResult(data)
        ? this.showResultDialog(data)
        : this.showExamCompleteDialog();
      dialog.then(() => this.finishExamAndLeave()).catch(() => this.finishExamAndLeave());
    },


    /** 问卷内返回：加载失败时父级关闭问卷壳并重拉 start；其余仅提示 */
    handleQuestionnaireGoBack(payload) {
      if (payload && payload.questionnaireLoadFailed) {
        this.showQuestionnaire = false;
        this.stopHeartbeat();
        this.stopCountdown();
        this.$toast("问卷加载失败，正在刷新考试状态");
        this.loadExamFromServer();
        return;
      }
      this.$toast("请先完成问卷，完成后即可查看考试结果");
    },
  },
};
</script>

<style lang="less" scoped>
.mobileCurriculum {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background-color: #f5f5f5;

  .loading {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    line-height: 50px;
    padding: 50px 20px;

    &.loading--error-state {
      padding: 32px 20px 48px;
    }

    .reload-exam-btn {
      margin-top: 24px;
      max-width: 280px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .exam-lock-mask {
    position: fixed;
    inset: 0;
    z-index: 3000;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    background: rgba(255, 255, 255, 0.82);
  }

  .exam-lock-mask--blocked {
    top: 46px;
    pointer-events: none;
  }

  .exam-lock-mask--takeover {
    pointer-events: auto;
  }

  .exam-lock-text {
    max-width: 280px;
    color: #1f2937;
    font-size: 15px;
    line-height: 1.5;
    text-align: center;
  }

  .exam-takeover-btn {
    width: 220px;
    max-width: calc(100vw - 64px);
  }

  .exam-build-version {
    position: fixed;
    top: 50px;
    right: 8px;
    z-index: 20;
    color: rgba(0, 0, 0, 0.35);
    font-size: 10px;
    line-height: 1;
    pointer-events: none;
    user-select: none;
  }

  .exam-content {
    padding-bottom: 30px;

    // 考试信息卡片（固定在顶部）
    .exam-info-card {
      position: sticky;
      top: 0;
      z-index: 100;
      background-color: #fff;
      padding: 16px;
      margin-bottom: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

      .exam-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 12px;
        line-height: 1.5;
      }

      .exam-meta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;

        .meta-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;

          .meta-label {
            font-size: 12px;
            color: #999;
          }

          .meta-value {
            font-size: 16px;
            font-weight: 600;
            color: #333;

            &.time-value {
              color: #0095ff;

              &.time-warning {
                color: #ff4d4f;
                animation: time-warning-pulse 1s ease-in-out infinite;
              }
            }
          }
        }

        .meta-divider {
          width: 1px;
          height: 30px;
          background-color: #e8e8e8;
        }
      }
    }

    // 题目内容区域
    .question-content {
      padding: 0 16px;
      padding-bottom: 30px;

      &.has-fixed-buttons {
        padding-bottom: 100px; // 为固定按钮留出空间
      }

      .question-card {
        background-color: #fff;
        border-radius: 8px;
        padding: 20px 16px;
        margin-bottom: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

        .question-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          padding-bottom: 12px;
          border-bottom: 1px solid #f0f0f0;

          .question-type-badge {
            display: inline-block;
            padding: 4px 12px;
            background-color: #e6f7ff;
            color: #0095ff;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
          }

          .question-number {
            font-size: 14px;
            color: #999;
          }
        }

        .question-title {
          font-size: 16px;
          line-height: 1.6;
          color: #333;
          margin-bottom: 20px;
          word-wrap: break-word;
          word-break: break-word;
        }

        // 选项容器
        .options-container {
          display: flex;
          flex-direction: column;
          gap: 12px;

          .option-card {
            display: flex;
            align-items: center;
            padding: 16px;
            background-color: #fafafa;
            border: 2px solid #e8e8e8;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s ease;
            min-height: 56px;

            &:active {
              transform: scale(0.98);
            }

            &.selected {
              background-color: #e6f7ff;
              border-color: #0095ff;

              .option-radio.checked,
              .option-checkbox.checked {
                background-color: #0095ff;
                border-color: #0095ff;

                &::after {
                  opacity: 1;
                }
              }
            }

            .option-label {
              font-size: 16px;
              font-weight: 600;
              color: #0095ff;
              margin-right: 12px;
              flex-shrink: 0;
            }

            .option-text {
              flex: 1;
              font-size: 16px;
              line-height: 1.5;
              color: #333;
              word-wrap: break-word;
              word-break: break-word;
            }

            .option-radio,
            .option-checkbox {
              width: 20px;
              height: 20px;
              border: 2px solid #d9d9d9;
              border-radius: 50%;
              flex-shrink: 0;
              margin-left: 12px;
              position: relative;
              transition: all 0.3s ease;

              &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-radius: 50%;
                opacity: 0;
                transition: opacity 0.3s ease;
              }

              &.checked {
                background-color: #0095ff;
                border-color: #0095ff;

                &::after {
                  opacity: 1;
                }
              }
            }

            .option-checkbox {
              border-radius: 4px;

              &::after {
                width: 6px;
                height: 10px;
                border: 2px solid #fff;
                border-top: none;
                border-left: none;
                background-color: transparent;
                border-radius: 0;
                transform: translate(-50%, -60%) rotate(45deg);
              }
            }
          }
        }

        // 简答题容器
        .textarea-container {
          margin-top: 12px;

          .answer-textarea {
            :deep(.el-textarea__inner) {
              border-radius: 8px;
              border: 2px solid #e8e8e8;
              font-size: 16px;
              line-height: 1.6;
              padding: 12px;

              &:focus {
                border-color: #0095ff;
              }
            }
          }
        }
      }

      // 导航按钮（相对定位，在内容流中）
      .nav-buttons.relative-position {
        position: relative;
        margin-top: 20px;

        .nav-btn {
          width: 100%;
          height: 44px;
          font-size: 16px;
          border-radius: 8px;
          background-color: #0095ff;
          border: none;
        }
      }
    }

    // 导航按钮（固定定位，悬浮在底部）
    .nav-buttons.fixed-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 12px 16px;
      background-color: #fff;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
      z-index: 1000;

      .nav-btn {
        width: 100%;
        height: 44px;
        font-size: 16px;
        border-radius: 8px;
        background-color: #0095ff;
        border: none;
      }
    }
  }

  .exam-finish-mask {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(0, 0, 0, 0.45);
  }

  .exam-finish-dialog {
    width: 100%;
    max-width: 320px;
    max-height: 80vh;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 24px 20px 18px;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  }

  .exam-finish-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.5;
    color: #333;
  }

  .exam-finish-title.echoPassTitle {
    color: #07c160;
  }

  .exam-finish-title.echoErrorTitle {
    color: #ee0a24;
  }

  .exam-finish-content {
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.6;
    color: #555;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .exam-finish-image {
    display: block;
    max-width: 100%;
    margin: 14px auto 0;
    border-radius: 4px;
  }

  .exam-finish-confirm {
    margin-top: 20px;
    height: 40px;
    border-radius: 6px;
  }
}

// 时间警告动画
@keyframes time-warning-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

// 禁用状态
:deep(.van-button--disabled) {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
